import { Anchor, Label, Text, TextButton } from '@zillow/constellation-10';
import { Flex } from '@zillow/constellation';
import React from 'react';

type Props = {
  clearAriaLabel: string;
  isClearDisabled: boolean;
  onClearClick(): void;
  subtitle: string;
};

export default ({ clearAriaLabel, isClearDisabled, onClearClick, subtitle }: Props) => (
  <Flex data-testid="subheading" display="flex" justifyContent="space-between" paddingY={1}>
    <Label data-testid="subheading-subtitle" color="text.subtle">
      {subtitle}
    </Label>

    <Text color="text.subtle" textStyle="body-sm">
      <Anchor asChild data-testid="subheading-button-clear" aria-label={clearAriaLabel} onClick={onClearClick}>
        <TextButton
          disabled={isClearDisabled}
          textStyle="body-sm"
          tone="subtle"
          css={{ textDecorationColor: 'text.subtle' }}
        >
          Clear
        </TextButton>
      </Anchor>
    </Text>
  </Flex>
);
